// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__oIZg1","summary":"CartItem_summary__0a8-y","price":"CartItem_price__tMGZi","amount":"CartItem_amount__a7Jij","actions":"CartItem_actions__3dr9D"};